import { urlRoutes } from 'presentation/routes/config/urlRoutes/urlRoutes'
import { generalBackgroundHistoryText } from 'presentation/constant/texts/sidebar'
import {
  availableDestinationsText,
  consultRepresentativeDetailsText,
  selectedDestinationsText,
} from 'presentation/constant/globals'

export const sideBarElements = [
  {
    id: 1,
    route: urlRoutes.private.goalAssignment.urlTo,
    expandedName: 'panel1',
    ariaControls: 'panel1d-content',
    panelId: 'panel1d-header',
    name: generalBackgroundHistoryText,
  },
  {
    id: 2,
    route: urlRoutes.private.representatives.load.urlTo,
    expandedName: 'panel2',
    ariaControls: 'panel2d-content',
    panelId: 'panel2d-header',
    name: consultRepresentativeDetailsText,
  },
  {
    id: 3,
    route: urlRoutes.private.availableDestinations.urlTo,
    expandedName: 'panel3',
    ariaControls: 'panel3d-content',
    panelId: 'panel3d-header',
    name: availableDestinationsText,
  },
  {
    id: 4,
    route: urlRoutes.private.selectedDestinations.urlTo,
    expandedName: 'panel4',
    ariaControls: 'panel4d-content',
    panelId: 'panel4d-header',
    name: selectedDestinationsText,
  },
]
